import {BaseModel} from '@/core/standard/BaseModel';
import DigitalMenuSettingsServices from '@/modules/settings/digital-menu/DigitalMenuSettingsServices';
import {
  DigitalMenuSettingsProtocol,
  IDigitalMenus,
  IDigitalMenuSettingsModel,
} from '@/modules/settings/digital-menu/IDigitalMenuSettingsModel';

const digitalMenuSettings = {
  logo: '',
  header_image: '',
  kiosko_image: '',
  title: '',
  title_es: '',
  title_en: '',
  subtitle: '',
  subtitle_es: '',
  subtitle_en: '',
  description: '',
  description_es: '',
  description_en: '',
  principal_color: '',
  page_background_color: '',
  header_background_color: '',
  minimal_order_domicile: 0,
  allow_tips: false,
  email: '',
  bookings: false,
  call_waiter: false,
  local_orders: false,
  use_awards: false,
  message_order_accepted: '',
  message_order_cash_accepted_kiosko: '',
  message_order_card_accepted_kiosko: '',
  message_order_accepted_es: '',
  message_order_cash_accepted_kiosko_es: '',
  message_order_card_accepted_kiosko_es: '',
  message_order_accepted_en: '',
  message_order_cash_accepted_kiosko_en: '',
  message_order_card_accepted_kiosko_en: '',
};


// tslint:disable-next-line:max-line-length
class DigitalMenuSettingsModel extends BaseModel<IDigitalMenuSettingsModel, DigitalMenuSettingsProtocol, typeof DigitalMenuSettingsServices> {
  public modelName = 'App';

  public request = 'FormData';

  constructor() {
    super(digitalMenuSettings, DigitalMenuSettingsServices);
  }

  public async create(data: FormData, toast: any, toastConfig: any) {
    if (!data.has('logo')) {
      data.append('logo', '');
    } else if (data.has('logo') && !(data.get('logo') instanceof File)) {
      data.delete('logo');
    }
    if (!data.has('header_image')) {
      data.append('header_image', '');
    } else if (data.has('header_image') && !(data.get('header_image') instanceof File)) {
      data.delete('header_image');
    }
    if (!data.has('kiosko_image')) {
      data.append('kiosko_image', '');
    } else if (data.has('kiosko_image') && !(data.get('kiosko_image') instanceof File)) {
      data.delete('kiosko_image');
    }
    if (!data.has('subtitle')) {
      data.append('subtitle', '');
      data.set('subtitle_en', '');
    }
    if (!data.has('title')) {
      data.append('title', '');
      data.set('title_en', '');
    }
    if (!data.has('description')) {
      data.append('description', '');
      data.set('description_en', '');
    }
    if (!data.has('email')) {
      data.append('email', '');
    }
    if (!data.has('message_order_accepted')) {
      data.append('message_order_accepted', '');
      data.set('message_order_cash_accepted_kiosko_en', '');
    }
    if (!data.has('message_order_cash_accepted_kiosko')) {
      data.append('message_order_cash_accepted_kiosko', '');
      data.set('message_order_cash_accepted_kiosko_en', '');
    }
    if (!data.has('message_order_card_accepted_kiosko')) {
      data.append('message_order_card_accepted_kiosko', '');
      data.set('message_order_card_accepted_kiosko_en', '');
    }

    const request = await this.service.request({method: 'PUT', query: data});
    if (request.complete) {
      return this.handleSuccess(request.data, request.message, toast);
    } else {
      this.handleError(request, toast);
      return false;
    }
  }

}

export default DigitalMenuSettingsModel as new() => IDigitalMenus;
